import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LayoutRoutingModule} from '@app/modules/layout/layout-routing.module';
import {TranslateModule} from '@ngx-translate/core';
import {FormsModule} from '@angular/forms';
import {NgbDropdownModule, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {NgxLoadingModule} from 'ngx-loading';
import {LayoutComponent} from '@app/modules/layout/layout.component';
import {SidebarComponent} from '@app/components/sidebar/sidebar.component';
import {HeaderComponent} from '@app/components/header/header.component';

@NgModule({
  imports: [
    CommonModule,
    LayoutRoutingModule,
    TranslateModule,
    NgbDropdownModule,
    NgxLoadingModule,
    FormsModule,
    NgbModule,
    LayoutComponent,
    HeaderComponent,
    SidebarComponent,
  ],
  declarations: [],
  bootstrap: []
})
export class LayoutModule {
}
